import { render, staticRenderFns } from "./VerifyIssuerOrganization.vue?vue&type=template&id=36269fdc"
import script from "./VerifyIssuerOrganization.vue?vue&type=script&lang=js"
export * from "./VerifyIssuerOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports